module.exports = __webpack_public_path__ + "img/logo2.ea927b4a.png";